"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateCardNumber = exports.validateCardFields = exports.validateCardExpiration = exports.validateCardCvv = exports.isMatchExpiration = exports.getExpirationValues = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _endOfMonth = _interopRequireDefault(require("date-fns/endOfMonth"));
var _isWithinInterval = _interopRequireDefault(require("date-fns/isWithinInterval"));
var _addYears = _interopRequireDefault(require("date-fns/addYears"));
var _parse = _interopRequireDefault(require("date-fns/parse"));
var _constants = require("./constants");
/**
 * Mod10 algorithm to check card validity
 * https://en.wikipedia.org/wiki/Luhn_algorithm
 * @param {string} value - card number
 */
var luhnCheck = function luhnCheck(value) {
  return value.split('').reverse().map(function (x) {
    return parseInt(x, 10);
  }).map(function (x, idx) {
    return idx % 2 ? x * 2 : x;
  }).map(function (x) {
    return x > 9 ? x % 10 + 1 : x;
  }).reduce(function (accum, x) {
    return accum += x;
  }) % 10 === 0;
}; //eslint-disable-line

/**
 *
 * @param {String} value
 */
var getExpirationValues = exports.getExpirationValues = function getExpirationValues(value) {
  // first two digits
  var expMonth = value.substr(0, 2);
  // last 2 digits after expMonth
  var expYear = value.substr(2).substr(-2);
  return [expMonth, expYear];
};
var validateCardNumber = exports.validateCardNumber = function validateCardNumber(value) {
  var availableCardCount = [16, 18, 19];
  var isSizeValid = (0, _includes2["default"])(availableCardCount, (0, _size2["default"])(value));
  return isSizeValid && luhnCheck(value);
};

/**
 * Пропускать все карты с 2022 года вне зависимости от месяца
 * @see https://leveltravel.atlassian.net/browse/LT-25673
 */
var validateCardExpiration = exports.validateCardExpiration = function validateCardExpiration(value) {
  var expDateRegex = /^\d{4}$/;
  if (expDateRegex.test(value)) {
    var parseValue = (0, _parse["default"])(value, 'MMyy', new Date());
    var expDate = (0, _endOfMonth["default"])(parseValue);
    return expDate && isMatchExpiration(expDate);
  }
  return false;
};
var isMatchExpiration = exports.isMatchExpiration = function isMatchExpiration(value) {
  var START_DATE = (0, _parse["default"])('0122', 'MMyy', new Date());
  var MAX_ALLOWED_CARD_DATE = (0, _addYears["default"])(START_DATE, 20);
  var matchInterval = (0, _isWithinInterval["default"])(value, {
    start: START_DATE,
    end: MAX_ALLOWED_CARD_DATE
  });
  return matchInterval;
};
var validateCardCvv = exports.validateCardCvv = function validateCardCvv(value) {
  return (0, _size2["default"])(value) === 3;
};
var validateCardFields = exports.validateCardFields = function validateCardFields(props) {
  var number = props.number,
    expDate = props.expDate,
    cvv = props.cvv;
  return (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _constants.CARD_FIELDS.NUMBER.id, validateCardNumber(number)), _constants.CARD_FIELDS.EXP_DATE.id, validateCardExpiration(expDate)), _constants.CARD_FIELDS.CVV.id, validateCardCvv(cvv));
};